import { Checkbox, CheckboxProps } from 'primereact/checkbox';
import { withFormControl } from '../with-form-control';

export const FormCheckbox = withFormControl<CheckboxProps>((props) => {
  const { value, id, ...other } = props;
  return <Checkbox inputId={id} checked={value} {...other} />;
});
